<ng-container *ngIf="appointment && isLoaded">
	<ion-grid>
		<ion-row *ngFor="let ccType of clearCodeTypes; index as index">
			<ion-col size="12">
				<ion-label>
					{{ ccType.desc }}
				</ion-label>
			</ion-col>
			<ion-col size="12">
				<ion-select
					placeholder="Select"
					(ionChange)="onChangeUpdateSelect($event, index)"
					[disabled]="!hasOptions(index)"
					[interfaceOptions]="{ header: ccType.desc }"
					[compareWith]="compareWith"
					[value]="
						codes[index] ? codes[index].ticketClearCodeOption : null
					"
				>
					<ng-container
						*ngIf="
							dropdownOptions[index]?.length > 0;
							else noValidOptions
						"
					>
						<ion-select-option
							*ngFor="let option of dropdownOptions[index]"
							[value]="option"
						>
							{{ option.desc }}
						</ion-select-option>
					</ng-container>
					<ng-template #noValidOptions>
						<ion-select-option [value]="undefined" disabled>
							<ion-label>No Valid Options</ion-label>
						</ion-select-option>
					</ng-template>
				</ion-select>
			</ion-col>
		</ion-row>
	</ion-grid>
</ng-container>
